import script from "./AuctionSponsors.vue?vue&type=script&setup=true&lang=js"
export * from "./AuctionSponsors.vue?vue&type=script&setup=true&lang=js"

import "./AuctionSponsors.vue?vue&type=style&index=0&id=71a30f34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a30f34"]])

export default __exports__